import React from 'react';

import {Monster, useMonsterQuery} from '../../../../generated/types';
import {MonsterStatblock} from '../../../monster-view/monster-statblock';
import {toMonsterTypeLine} from '../../../render-helpers/to-monster-type-line';
import {Link} from '../../../../lib/routes';
import {MarkdownPlugin} from './plugin';

import css from './statblock.plugin.module.css';

type Props = {
	args: string[];
};

// {@statblock monster-id} — блок параметров чудовища целиком
export const StatblockPlugin: MarkdownPlugin<Props> = ({args}) => {
	const [id] = args;
	const {data} = useMonsterQuery({variables: {id}, skip: !id});
	const monster = data?.monster;

	if (!monster) return null;

	return (
		<div className={css.statblock}>
			<div className={css.header}>
				<Link route="monster" params={{id}} className={css.title}>
					{monster.title}
				</Link>
				<em className={css.subTitle}>{toMonsterTypeLine(monster as Monster)}</em>
			</div>
			<MonsterStatblock monster={monster} />
		</div>
	);
};

// карточка, а не строчка текста: разбор ставит её отдельным блоком, а не внутрь абзаца
StatblockPlugin.block = true;
